import { render, staticRenderFns } from "./ModalSolicitacaoFerias.vue?vue&type=template&id=f613f09a&scoped=true"
import script from "./ModalSolicitacaoFerias.vue?vue&type=script&lang=js"
export * from "./ModalSolicitacaoFerias.vue?vue&type=script&lang=js"
import style0 from "./ModalSolicitacaoFerias.vue?vue&type=style&index=0&id=f613f09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f613f09a",
  null
  
)

export default component.exports